// This file is auto-generated during build
export const version = '1.0.0';
